import React from "react";
import { motion } from "framer-motion";
import { ArrowDown, Sparkles } from "lucide-react";

const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 lg:pt-40 pb-20 lg:pb-32 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="lg:col-span-7 relative z-10"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-[#EAE5D9] bg-[#F4F1EB]/60 px-4 py-1.5 text-xs uppercase tracking-[0.22em] text-[#5C605A]">
            <Sparkles className="h-3.5 w-3.5 text-[#C5A880]" />
            Reiki Grand Master · 5+ years
          </div>

          <h1 className="font-serif mt-7 text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] leading-[1.02] text-[#2C302E]">
            Quiet the noise.<br />
            <span className="italic text-[#B35B47]">Remember</span> who<br />
            you really are.
          </h1>

          <p className="mt-8 text-lg text-[#5C605A] max-w-xl leading-relaxed">
            Soulful Reiki, Past Life Regression, Crystal Healing and Astrology
            Guidance — held with deep care by Archana Tiwari, founder of
            Aura Bliss Reiki.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-book"
              className="inline-flex items-center gap-2 rounded-full bg-[#2C302E] text-[#FAF9F6] px-7 py-3.5 text-sm tracking-wide hover:bg-[#B35B47] transition-colors"
            >
              Begin your journey
              <ArrowDown className="h-4 w-4 rotate-[-45deg]" />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-services"
              className="inline-flex items-center gap-2 rounded-full border border-[#2C302E]/30 text-[#2C302E] px-7 py-3.5 text-sm tracking-wide hover:bg-[#2C302E] hover:text-[#FAF9F6] transition-colors"
            >
              Explore healings
            </a>
          </div>

          <div className="mt-14 flex gap-10">
            <Stat number="500+" label="Healing sessions" />
            <Stat number="5+ yrs" label="Of practice" />
            <Stat number="9 paths" label="Of healing" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-6 bg-gradient-to-br from-[#C5A880]/30 to-transparent rounded-[2.5rem] blur-2xl" />
          <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] glow-soft">
            <img
              src="https://images.unsplash.com/photo-1461468611824-46457c0e11fd"
              alt="Serene woman by the sea"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#FAF9F6] border border-[#EAE5D9] rounded-2xl px-5 py-4 shadow-sm animate-float">
            <div className="text-xs uppercase tracking-[0.22em] text-[#8A8D86]">Today's intention</div>
            <div className="font-serif italic text-lg text-[#2C302E] mt-1">"I am held, I am whole."</div>
          </div>
        </motion.div>
      </div>

      {/* Decorative aura ring */}
      <div className="pointer-events-none absolute -top-32 -right-40 h-[34rem] w-[34rem] rounded-full bg-[#C5A880]/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-32 h-[28rem] w-[28rem] rounded-full bg-[#8A9A86]/20 blur-3xl" />
    </section>
  );
};

const Stat = ({ number, label }) => (
  <div>
    <div className="font-serif text-3xl text-[#2C302E]">{number}</div>
    <div className="text-xs uppercase tracking-[0.18em] text-[#8A8D86] mt-1">{label}</div>
  </div>
);

export default Hero;
